import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import InfoIcon from '../InfoIcon';
import Text, { SIZES, SKINS, WEIGHTS } from '../Text';
import { dataHooks } from './constants';
import styles from './FormField.st.css';
import { TooltipCommonProps } from '../common/PropTypes/TooltipCommon';
var PLACEMENT = {
  top: 'top',
  right: 'right',
  left: 'left'
};
var ALIGN = {
  middle: 'middle',
  top: 'top'
};
var asterisk = /*#__PURE__*/React.createElement("div", {
  "data-hook": dataHooks.asterisk,
  className: styles.asterisk,
  children: "*"
});

var charactersLeft = function charactersLeft(lengthLeft) {
  var colorProps = lengthLeft >= 0 ? {
    light: true,
    secondary: true
  } : {
    skin: SKINS.error
  };
  return /*#__PURE__*/React.createElement(Text, _extends({
    size: SIZES.small,
    weight: WEIGHTS.normal
  }, colorProps, {
    dataHook: dataHooks.counter,
    children: lengthLeft
  }));
};

var FormField = /*#__PURE__*/function (_React$Component) {
  _inherits(FormField, _React$Component);

  var _super = _createSuper(FormField);

  function FormField() {
    var _this;

    _classCallCheck(this, FormField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      lengthLeft: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "childrenRenderPropInterface", {
      setCharactersLeft: function setCharactersLeft(lengthLeft) {
        return _this.setState({
          lengthLeft: lengthLeft
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_hasCharCounter", function () {
      return _this.props.charCount !== undefined || typeof _this.state.lengthLeft === 'number';
    });

    _defineProperty(_assertThisInitialized(_this), "_renderCharCounter", function () {
      if (!_this._hasCharCounter()) {
        return;
      }

      var charCount = _this.props.charCount;
      return charactersLeft(charCount !== undefined ? charCount : _this.state.lengthLeft);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderInfoIcon", function () {
      var _this$props = _this.props,
          dataHook = _this$props.dataHook,
          infoContent = _this$props.infoContent,
          infoTooltipProps = _this$props.infoTooltipProps,
          labelSize = _this$props.labelSize;
      return infoContent && /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: "".concat(dataHook, "-formfield-infoicon"),
        className: styles.infoIcon,
        content: infoContent,
        tooltipProps: infoTooltipProps,
        size: labelSize
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderLabelIndicators", function () {
      var _this$props2 = _this.props,
          required = _this$props2.required,
          suffix = _this$props2.suffix;
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-hook": dataHooks.labelIndicators
      }, styles('labelIndicators', {
        inlineWithSuffix: suffix || _this._hasCharCounter()
      })), _this._renderLabel({
        trimLongText: false
      }), required && asterisk, _this._renderInfoIcon());
    });

    _defineProperty(_assertThisInitialized(_this), "_renderSuffix", function () {
      var suffix = _this.props.suffix;
      return (suffix || _this._hasCharCounter()) && /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.suffix,
        className: styles.suffix
      }, suffix ? suffix : _this._renderCharCounter());
    });

    _defineProperty(_assertThisInitialized(_this), "_hasInlineLabel", function (label, labelPlacement) {
      return label && (labelPlacement === PLACEMENT.left || labelPlacement === PLACEMENT.right);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderLabel", function (_ref) {
      var trimLongText = _ref.trimLongText;
      var _this$props3 = _this.props,
          label = _this$props3.label,
          labelSize = _this$props3.labelSize,
          id = _this$props3.id;
      return /*#__PURE__*/React.createElement(Text, {
        size: labelSize,
        htmlFor: id,
        tagName: 'label',
        dataHook: dataHooks.label,
        ellipsis: trimLongText,
        style: {
          display: 'block'
        } // allows the label to middle vertically
        ,
        secondary: true
      }, label);
    });

    return _this;
  }

  _createClass(FormField, [{
    key: "_renderChildren",
    value: function _renderChildren() {
      var children = this.props.children;

      if (typeof children === 'function') {
        return children(this.childrenRenderPropInterface);
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          label = _this$props4.label,
          labelPlacement = _this$props4.labelPlacement,
          labelAlignment = _this$props4.labelAlignment,
          required = _this$props4.required,
          infoContent = _this$props4.infoContent,
          dataHook = _this$props4.dataHook,
          children = _this$props4.children,
          classNames = _this$props4.classNames,
          stretchContent = _this$props4.stretchContent;
      var rootStyles = label ? {
        labelPlacement: labelPlacement,
        labelAlignment: labelAlignment,
        stretchContent: stretchContent,
        minLabelHeight: !children
      } : {
        stretchContent: stretchContent,
        minLabelHeight: !children
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        "data-hook": dataHook
      }, styles('root', rootStyles, {
        classNames: classNames
      })), label && labelPlacement === PLACEMENT.top && /*#__PURE__*/React.createElement("div", {
        className: styles.label
      }, this._renderLabel({
        trimLongText: true
      }), required && asterisk, this._renderInfoIcon(), this._renderSuffix()), children && /*#__PURE__*/React.createElement("div", _extends({
        "data-hook": dataHooks.children
      }, styles('children', {
        childrenWithInlineLabel: !label || this._hasInlineLabel(label, labelPlacement)
      })), (!label || labelPlacement !== PLACEMENT.top) && this._renderSuffix(), this._renderChildren()), !label && (required || infoContent) && this._renderLabelIndicators(), this._hasInlineLabel(label, labelPlacement) && this._renderLabelIndicators());
    }
  }]);

  return FormField;
}(React.Component);

_defineProperty(FormField, "displayName", 'FormField');

_defineProperty(FormField, "propTypes", {
  /**
   * any kids to render, should be some form of input. Input, InputArea & RichTextArea work well
   *
   * `children` can be React node or a function
   *
   * when function, it receives object with:
   * * `setCharactersLeft` - function accepts a number and will display it on top right of `FormField` component
   *
   * Note that alternatively you can also use `charCount` prop to display character count
   * instead of using the render function method.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

  /** character count displayed on top right of the component */
  charCount: PropTypes.number,

  /** A custom element to appear on the end of the label row (it overrides the charCount in case it's provided) */
  suffix: PropTypes.node,

  /** Defines if the content (children container) grows when there's space available (otherwise, it uses the needed space only) */
  stretchContent: PropTypes.bool,

  /** optional text labeling this form field */
  label: PropTypes.node,

  /** setting label size (small, medium) */
  labelSize: PropTypes.oneOf(['small', 'medium']),

  /** label placement (top, left, right) */
  labelPlacement: PropTypes.oneOf([PLACEMENT.top, PLACEMENT.right, PLACEMENT.left]),

  /** label alignment  */
  labelAlignment: PropTypes.oneOf([ALIGN.middle, ALIGN.top]),

  /** whether to display an asterisk (*) or not */
  required: PropTypes.bool,

  /** display info icon with tooltip. Node from this prop is content of tooltip */
  infoContent: PropTypes.node,

  /** info icon tooltip props */
  infoTooltipProps: PropTypes.shape(TooltipCommonProps),

  /** string used to match text label with FormField children. For example:
   *
   * ```js
   * <FormField id="myFormField" label="Hello">
   *   <Input id="myFormField"/>
   * </FormField>
   * ```
   */
  id: PropTypes.string,

  /** used for testing */
  dataHook: PropTypes.string
});

_defineProperty(FormField, "defaultProps", {
  labelSize: 'medium',
  required: false,
  stretchContent: true,
  labelPlacement: PLACEMENT.top,
  labelAlignment: ALIGN.middle
});

export default FormField;